module.exports = __webpack_public_path__ + "static/media/circle-info-regular.a7403be2.svg";